import { GetAgencyProfileResponse, GetUserProfileResponse } from "Application/models";
import { APICallInstance } from "./APICallInstance";
import { AxiosResponse } from "axios";

class ProfileServiceClass {
    getAgencyProfile = async (agencyId: number) => {
        const url = `/api/v1/agencies/profile/${agencyId}`;
    
        try {
            const response: AxiosResponse<GetAgencyProfileResponse> = await APICallInstance.get(url);
            console.log(response)
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    getUserProfile = async (userId: number) => {
        const url = `/api/v1/users/${userId}/profile`;
    
        try {
            const response: AxiosResponse<GetUserProfileResponse> = await APICallInstance.get(url);
            console.log(response)
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const ProfileService = new ProfileServiceClass()
